import { useAuth0 } from '@auth0/auth0-react';
import useContextMyBrands from 'hooks/contexts/useContextMyBrands';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { messageInfo } from 'views/components/UI/message';
import * as path from 'router/paths';
import useContextCatalog from 'hooks/contexts/useContextCatalog';

export const LoginRequired = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  // const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
      // navigate('/authentication/signup')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isAuthenticated]);

  return children;
};

export const NoCatalogRedirectToHome = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const { connectedBrands, isLoadingGetMyBrands } = useContextMyBrands();
  const { isLoading: isLoadingCatalog } = useContextCatalog();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    if (
      isMounted &&
      !isLoadingGetMyBrands &&
      connectedBrands.length === 0 &&
      location.pathname === `/${path.catalog}` &&
      !isLoadingCatalog
    ) {
      messageInfo(
        'No hay catálogos disponibles, por favor, añade una asociación para obtener su catálogo.',
        5
      );
      setTimeout(() => {
        navigate(path.home);
      }, 1000);
      return;
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingGetMyBrands, connectedBrands.length, location.pathname, isLoadingCatalog]);

  return children;
};
